import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { integer } from "aws-sdk/clients/storagegateway";


const SettingsList = (props: any) => {
    const [properties, setProperties] = useState<any>([]);

    useEffect(() => {
        setProperties(props.properties);
    }, [props.properties]);

    const editSource = (prop:any) => {
        //console.log("editSource > prop", prop)
        if(props.onSelectedPropertyId) {
            props.onSelectedPropertyId(prop.id);
        }
    }
    //console.log("props", props)
    return (
        <>
        <Table striped bordered hover variant="dark">
            <thead>
                <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Shortcode</th>
                    <th>Category</th>
                    <th>Type</th>
                </tr>
            </thead>
            <tbody>
                {
                    properties.map((prop:any, index:integer) => (
                        <tr key={index}>
                            <td>
                                <Button 
                                    variant="primary"
                                    size="sm"
                                    onClick={() => editSource(prop)}>
                                        Edit
                                </Button>
                            </td>
                            <td>{prop.name}</td>
                            <td>{prop.shortcode}</td>
                            <td>{prop.category_name}</td>
                            <td>{prop.type_name}</td>
                        </tr>
                    ))
                }
            </tbody>
            </Table>
        </>
    );
}

export default SettingsList;